
import { useEffect } from 'react';
import Header from '@/components/Header';
import FooterSection from '@/components/FooterSection';
import CustomSolutionsHero from '@/components/customsolutions/CustomSolutionsHero';
import CustomSolutionsFuture from '@/components/customsolutions/CustomSolutionsFuture';
import CustomSolutionsWorkflow from '@/components/customsolutions/CustomSolutionsWorkflow';
import CustomSolutionsExamples from '@/components/customsolutions/CustomSolutionsExamples';
import CustomSolutionsIntegration from '@/components/customsolutions/CustomSolutionsIntegration';
import CustomSolutionsCallToAction from '@/components/customsolutions/CustomSolutionsCallToAction';

const CustomWorkflows = () => {
  useEffect(() => {
    // Update document title
    document.title = 'Custom AI Solutions | DocketLabs';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Custom AI solutions tailored for your law firm\'s unique workflows. Streamline operations with bespoke legal AI tools. Get started today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Custom AI solutions tailored for your law firm\'s unique workflows. Streamline operations with bespoke legal AI tools. Get started today.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow bg-background text-foreground">
        <CustomSolutionsHero />
        <CustomSolutionsFuture />
        <CustomSolutionsWorkflow />
        <CustomSolutionsExamples />
        <CustomSolutionsIntegration />
        <CustomSolutionsCallToAction />
      </main>
      <FooterSection />
    </div>
  );
};

export default CustomWorkflows;
